import React from "react";

import VoiceClipPlayerPlaceholder from "@/pages/Voice/CloneVoice/VoiceClipPlaceholder";
import { VoiceClipPlaceholder } from "@/pages/Voice/types";

interface IVoiceClipContainerProps {
  deleteClip(name: string): void;
  clips: VoiceClipPlaceholder[];
}

const VoiceClipsPlaceholdersContainer = ({ clips, deleteClip }: IVoiceClipContainerProps) => {
  if (!clips?.length) return null;

  const voicePlayerActions = {
    handleDeleteClick: deleteClip,
  };

  return (
    <div className="flex flex-col gap-lg py-lg">
      {clips.map((clip: VoiceClipPlaceholder) => (
        <VoiceClipPlayerPlaceholder key={clip.id} audioFile={clip} {...voicePlayerActions} />
      ))}
    </div>
  );
};
export default VoiceClipsPlaceholdersContainer;
